import { createSlice } from "@reduxjs/toolkit";
import { authConstants, userConstants } from "@/config/constants";
import { isUserLoggedIn } from "@/shared/helpers/authHelper";
import { loginThunk } from "./loginThunk";

export { loginThunk };

const resolvePasswordChangeRequired = (payload: any = {}) => {
  return payload?.is_temp_password_active === 1;
};

const initialState = {
  isUserLoggedIn: isUserLoggedIn() || false,
  error: null,
  loading: false,
  hasLoggedOut: false,
  isPasswordChangeRequired: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetHasLoggedOut(state) {
      state.hasLoggedOut = false;
    },
    resetLogin(state) {
      state.isUserLoggedIn = false;
      state.loading = false;
      state.error = null;
      state.hasLoggedOut = false;
      state.isPasswordChangeRequired = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isUserLoggedIn = false;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        state.isUserLoggedIn = isUserLoggedIn(action.payload?.token);
        state.loading = false;
        state.error = null;
        state.hasLoggedOut = false;
        state.isPasswordChangeRequired = resolvePasswordChangeRequired(
          action.payload?.user_detail
        );
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.error = action.payload || "Login failed";
        state.loading = false;
        state.isUserLoggedIn = false;
      })
      .addCase(userConstants.GET_USER_SUCCESS, (state, action: any) => {
        state.isPasswordChangeRequired = resolvePasswordChangeRequired(
          action.payload
        );
      })
      .addCase(authConstants.LOGOUT, () => ({
        ...initialState,
        isUserLoggedIn: false,
        hasLoggedOut: true,
      }))
      .addCase(authConstants.RESET_HAS_LOGGED_OUT, (state) => {
        state.hasLoggedOut = false;
      })
      .addCase(authConstants.RESET_LOGIN, () => ({
        ...initialState,
        isUserLoggedIn: false,
      }));
  },
});

export const { resetHasLoggedOut, resetLogin } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const isLoggedInSelector = (state: any) => state.auth.isUserLoggedIn;
export const authLoadingSelector = (state: any) => state.auth.loading;
export const authErrorSelector = (state: any) => state.auth.error;
export const hasLoggedOutSelector = (state: any) => state.auth.hasLoggedOut;
export const isPasswordChangeRequiredSelector = (state: any) =>
  state.auth.isPasswordChangeRequired && !state?.user?.user?.is_master_pass;
